// Big Five display metadata shared by the full report (/tests/bigfive) and
// the profile's Personality card. Domain order + colours mirror the chart
// (bigfive-test.com reference); facet names are Johnson's IPIP-NEO-120 set
// (index = facet number - 1).

import type { BigFiveTrait } from "@careers/shared";

export const DOMAIN_META: Array<{
  key: BigFiveTrait;
  en: string;
  ja: string;
  color: string;
}> = [
  { key: "neuroticism", en: "Neuroticism", ja: "神経症的傾向", color: "#7C5CD6" },
  { key: "extraversion", en: "Extraversion", ja: "外向性", color: "#4F77E0" },
  { key: "openness", en: "Openness To Experience", ja: "開放性", color: "#D6597E" },
  { key: "agreeableness", en: "Agreeableness", ja: "協調性", color: "#E0A93F" },
  { key: "conscientiousness", en: "Conscientiousness", ja: "誠実性", color: "#5FB87A" },
];

export const FACET_LABELS: Record<BigFiveTrait, Array<{ en: string; ja: string }>> = {
  neuroticism: [
    { en: "Anxiety", ja: "不安" },
    { en: "Anger", ja: "怒り" },
    { en: "Depression", ja: "抑うつ" },
    { en: "Self-Consciousness", ja: "自意識" },
    { en: "Immoderation", ja: "無節制" },
    { en: "Vulnerability", ja: "傷つきやすさ" },
  ],
  extraversion: [
    { en: "Friendliness", ja: "友好性" },
    { en: "Gregariousness", ja: "社交性" },
    { en: "Assertiveness", ja: "自己主張" },
    { en: "Activity Level", ja: "活動性" },
    { en: "Excitement-Seeking", ja: "刺激希求" },
    { en: "Cheerfulness", ja: "快活さ" },
  ],
  openness: [
    { en: "Imagination", ja: "想像力" },
    { en: "Artistic Interests", ja: "芸術的関心" },
    { en: "Emotionality", ja: "情動性" },
    { en: "Adventurousness", ja: "冒険心" },
    { en: "Intellect", ja: "知性" },
    { en: "Liberalism", ja: "進歩性" },
  ],
  agreeableness: [
    { en: "Trust", ja: "信頼" },
    { en: "Morality", ja: "道徳性" },
    { en: "Altruism", ja: "利他性" },
    { en: "Cooperation", ja: "協調性" },
    { en: "Modesty", ja: "謙虚さ" },
    { en: "Sympathy", ja: "共感性" },
  ],
  conscientiousness: [
    { en: "Self-Efficacy", ja: "自己効力感" },
    { en: "Orderliness", ja: "秩序性" },
    { en: "Dutifulness", ja: "義務感" },
    { en: "Achievement-Striving", ja: "達成追求" },
    { en: "Self-Discipline", ja: "自己規律" },
    { en: "Cautiousness", ja: "慎重さ" },
  ],
};
